var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2887 8.52069L12.2888 7.27069L11.0388 7.27059L11.039 5.85059L12.289 5.85069L12.2891 4.60069L13.7091 4.6008L13.709 5.8508L14.959 5.85091L14.9589 7.27091L13.7088 7.2708L13.7087 8.5208L12.2887 8.52069Z",
    fill: "#505255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99836 21.9907L2.99943 8.94561L8.17216 8.94603L8.17273 2.00042L17.8364 2.00122L17.8358 8.95612L22.9994 8.95654L22.9984 22.0016L2.99836 22L2.99836 21.9907ZM21.3712 20.3279L21.372 10.6208L17.8357 10.6205L17.8349 20.3276L21.3712 20.3279V20.3279ZM16.1985 20.3274L16.1999 3.66542L9.79986 3.6649L9.7985 20.3269L11.1985 20.327L11.199 14.5809L14.799 14.5812L14.7985 20.3273L16.1985 20.3274ZM8.17123 20.3268L8.17202 10.6197L4.62657 10.6194L4.62577 20.3265L8.17123 20.3268V20.3268Z",
    fill: "#505255"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0999 11.8312L19.4199 11.8311L19.4198 13.1911L21.0998 13.1912L21.0999 11.8312Z",
    fill: "#505255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.098 18.4318L19.418 18.4316L19.4179 19.7916L21.0979 19.7918L21.098 18.4318Z",
    fill: "#505255"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.098 15.132L19.418 15.1318L19.4179 16.4918L21.0979 16.492L21.098 15.132Z",
    fill: "#505255"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57844 11.8302L4.89844 11.8301L4.89833 13.1901L6.57833 13.1902L6.57844 11.8302Z",
    fill: "#505255"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57844 18.4308L4.89844 18.4307L4.89833 19.7907L6.57833 19.7908L6.57844 18.4308Z",
    fill: "#505255"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57844 15.13L4.89844 15.1299L4.89833 16.4899L6.57833 16.49L6.57844 15.13Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital24Px);
export default __webpack_public_path__ + "static/media/hospital_24px.24812b88545cd67fde47e626157c66ff.svg";
export { ForwardRef as ReactComponent };